module.exports = __webpack_public_path__ + "img/CH01-024-025.9890f1e3.jpg";